import { Pattern } from '@/components/patterns';
import { GoldenRule } from '@/components/ui/GoldenRule';
import { useShouldShowAd, getMockAd } from '@/lib/ads';

interface Props {
  /** Clé stable pour piocher la même mock-ad entre deux re-renders. */
  adKey?: string;
  className?: string;
}

/**
 * Bannière publicitaire pour la fiche EventDetail.
 * Encadrée par deux filets champagne, façon "réclame" de magazine entre deux rubriques.
 * Mock-ad pour l'instant — le rendu visuel est définitif, seul le contenu est factice.
 */
export function AdBannerDetail({ adKey, className }: Props) {
  const visible = useShouldShowAd('detail_banner');
  if (!visible) return null;
  const ad = getMockAd(adKey);

  return (
    <section className={`my-6 ${className ?? ''}`}>
      <GoldenRule />

      <a
        href={ad.url}
        target="_blank"
        rel="noopener noreferrer sponsored"
        className="block my-6 group"
        aria-label={`Annonce sponsorisée : ${ad.advertiser}`}
      >
        {/* Bannière 16/9 — équivalent visuel d'un MEDIUM_RECTANGLE adaptatif */}
        <div
          className="relative w-full rounded-md overflow-hidden flex items-center justify-center"
          style={{ aspectRatio: '16 / 9', backgroundColor: `rgb(var(--${ad.tone}))` }}
        >
          <Pattern id={ad.pattern} opacity={0.14} />
          <div className="relative text-center px-6 max-w-md">
            <div className="t-cap text-paper-elev/80 mb-2 uppercase tracking-[0.12em]">
              {ad.advertiser}
            </div>
            <div className="t-ed-xl text-paper-elev italic leading-tight">
              {ad.headline}
            </div>
          </div>
        </div>
      </a>

      <GoldenRule />

      <p className="t-mono-xs text-ink-3 mt-1 uppercase tracking-[0.1em]">
        Annonce · Sponsorisé
      </p>
    </section>
  );
}
